import React, { useEffect } from "react";
import { ConfirmDeleteIcon } from "../../Icons";
import { APP_NAME } from '../../Constants';
import "./AppDialog.css";

// أيقونة الحذف (Trash)
function TrashIcon() {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6667 18.3333V28.3333" stroke="#FF6467" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.3333 18.3333V28.3333" stroke="#FF6467" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M31.6666 9.99997V33.3333C31.6666 34.2174 31.3155 35.0652 30.6903 35.6903C30.0652 36.3154 29.2174 36.6666 28.3333 36.6666H11.6666C10.7826 36.6666 9.93474 36.3154 9.30962 35.6903C8.6845 35.0652 8.33331 34.2174 8.33331 33.3333V9.99997" stroke="#FF6467" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 9.99997H35" stroke="#FF6467" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3333 10V6.66667C13.3333 5.78261 13.6845 4.93477 14.3096 4.30965C14.9347 3.68453 15.7826 3.33334 16.6666 3.33334H23.3333C24.2174 3.33334 25.0652 3.68453 25.6903 4.30965C26.3155 4.93477 26.6666 5.78261 26.6666 6.66667V10" stroke="#FF6467" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// أيقونة التأكيد الجديدة (Success/Confirm)
function SuccessIcon() {
  return (
    <svg width="2.5rem" height="2.5rem" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_success)">
        <path d="M17.0717 27.19L10 20.1167L12.3567 17.76L17.0717 22.4733L26.4983 13.045L28.8567 15.4033L17.0717 27.19Z" fill="#22C55E" />
        <path fillRule="evenodd" clipRule="evenodd" d="M1.66663 20C1.66663 9.875 9.87496 1.66666 20 1.66666C30.125 1.66666 38.3333 9.875 38.3333 20C38.3333 30.125 30.125 38.3333 20 38.3333C9.87496 38.3333 1.66663 30.125 1.66663 20ZM20 35C18.0301 35 16.0796 34.612 14.2597 33.8582C12.4398 33.1044 10.7862 31.9995 9.39336 30.6066C8.00048 29.2137 6.89559 27.5601 6.14177 25.7402C5.38795 23.9204 4.99996 21.9698 4.99996 20C4.99996 18.0302 5.38795 16.0796 6.14177 14.2597C6.89559 12.4399 8.00048 10.7863 9.39336 9.3934C10.7862 8.00052 12.4398 6.89563 14.2597 6.1418C16.0796 5.38798 18.0301 5 20 5C23.9782 5 27.7935 6.58035 30.6066 9.3934C33.4196 12.2064 35 16.0218 35 20C35 23.9782 33.4196 27.7936 30.6066 30.6066C27.7935 33.4196 23.9782 35 20 35Z" fill="#22C55E" />
      </g>
      <defs>
        <clipPath id="clip0_success">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function AppDialog({
  open,
  theme,
  lang,
  title,
  message,
  onConfirm,
  onCancel,
  onClose,
  type = "alert",
  variant = "info", // "info" | "delete" | "confirm"
  confirmText = "Ok",
  cancelText = "Cancel",
  showCancel = false
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  let Icon = ConfirmDeleteIcon;
  let iconColor = "#00c2cf";
  let wrapStyles = {};
  let iconStyle = {};

  if (variant === "delete") {
    Icon = TrashIcon;
    iconColor = "#FF6467";
    wrapStyles = {
      backgroundColor: 'rgba(251, 44, 54, 0.05)',
      boxShadow: '0px 3px 15px -3px rgba(251, 44, 54, 0.2)'
    };
    iconStyle = {
      background: 'linear-gradient(135deg, rgba(251,44,54,0.25) 0, rgba(231,0,11,0.08) 100%)'
    };
  } else if (variant === "confirm") {
    Icon = SuccessIcon;
    iconColor = "#22C55E";
    wrapStyles = {
      backgroundColor: 'rgba(34, 197, 94, 0.06)',
      boxShadow: '0px 3px 15px -3px rgba(34, 197, 94, 0.2)'
    };
    iconStyle = {
      background: 'linear-gradient(135deg, rgba(34,197,94,0.25) 0, rgba(34,197,94,0.08) 100%)'
    };
  } else {
    // Info variant setup fixed
    iconColor = "#00c2cf";
    wrapStyles = {
      backgroundColor: 'rgba(0, 192, 199, 0.06)',
      boxShadow: '0px 3px 15px -3px rgba(0, 192, 199, 0.2)'
    };
    iconStyle = {
      background: 'linear-gradient(135deg, rgba(0, 192, 199, 0.25) 0, rgba(0, 192, 199, 0.08) 100%)'
    };
  }

  return (
    <div className={"appDialogOverlay  " + theme} onMouseDown={onClose}>
      <div className="appDialogCard" onMouseDown={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <button className="appDialogClose" onClick={onClose} aria-label="Close dialog">×</button>

        <div className="appDialogBody">
          <div className="appDialogIconWrap" style={wrapStyles}>
            <div className="appDialogIcon" style={iconStyle}>
              <span className="appDialogIconInk" style={{ color: iconColor }}>
                <Icon />
              </span>
            </div>
          </div>

          <div className="appDialogText" style={{ textAlign: lang === 'en' ? 'left' : 'right' }}>
            <div className="appDialogAppName">{`${APP_NAME} ${lang === 'en' ? 'says' : 'يقول'}`}</div>
            <div className="appDialogTitle">{title}</div>
            <div className="appDialogMessage">{message}</div>
          </div>
        </div>

        <div className="appDialogFooter">
          {type === "confirm" && showCancel && (
            <button className="appDialogBtn appDialogBtnGhost" onClick={() => {
              onCancel?.();
              onClose();
            }}>
              {cancelText}
            </button>
          )}

          <button
            className={`appDialogBtn ${variant === 'delete' ? 'appDialogBtnDanger' : 'appDialogBtnPrimary'}`}
            style={variant === 'confirm' ? { backgroundColor: '#22C55E', color: '#fff', border:'1px solid #22C55E' } : {}}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}